export function isOfficeHours(lang: string): boolean {
  const now = new Date();
  const options = { timeZone: "Asia/Tokyo", hour12: false };
  const hour = Number(
    now.toLocaleString("en-US", { ...options, hour: "numeric" })
  );
  const minute = Number(
    now.toLocaleString("en-US", { ...options, minute: "numeric" })
  );
  if (lang === "ja") {
    return (hour >= 9 && hour < 18) || (hour === 18 && minute <= 30);
  } else {
    const day = now.toLocaleString("en-US", {
      ...options,
      weekday: "long",
    });
    return day !== "Saturday" && day !== "Sunday" && hour >= 9 && hour < 18;
  }
}
